import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

export type MenuAlign = 'left' | 'right';

type ListProps = {
  $align: MenuAlign;
};

export const Container = styled.div`
  position: relative;
  display: inline-flex;
`;

export const TriggerWrap = styled.div`
  display: inline-flex;
`;

export const List = styled('ul', {
  shouldForwardProp: (prop) => prop !== '$align',
})<ListProps>`
  position: absolute;
  top: calc(100% + 6px);
  z-index: 20;
  min-width: 180px;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

  ${({ $align }) =>
    $align === 'right'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `}
`;

export const ItemButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.primaryText};
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: #f5f5f5;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: ${theme.colors.gray};
  }
`;
